var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GcBaseLayout',{key:_vm.pageKey,ref:"gc-base-layout",staticClass:"help-layout",attrs:{"title":_vm.title,"isXSmall":_vm.isXSmall,"isLarge":_vm.isLarge,"baseView":_vm.baseView,"backButtonEnable":false,"formsConfig":_vm.formsConfig},scopedSlots:_vm._u([{key:"headerContent",fn:function(){return [_c('GcHeaderContentStatic',{attrs:{"title":'Help'}})]},proxy:true}])},[_c('div',{staticClass:"content-body"},[_c('span',{staticClass:"title"},[_vm._v("Hot Keys")]),_c('div',{staticClass:"hot-key-data"},[_c('dx-data-grid',{attrs:{"columns":_vm.getColumns,"data-source":_vm.getDataSource,"columnChooser":{
          enabled: false,
        },"pager":{
          visible: false,
        },"searchPanel":{
          visible: false,
        },"repaint-changes-only":true}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }